import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { API } from "../context/AuthContext";
import Seo from "../components/Seo";
import { CheckCircle2, XCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function VerifyEmail() {
  const { t } = useLanguage();
  const { token } = useParams();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");
  const [verifiedEmail, setVerifiedEmail] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMessage("Token mancante"); return; }
    axios.get(`${API}/auth/verify-email/${token}`)
      .then(r => { setStatus("success"); setVerifiedEmail(r.data.email || ""); setMessage(r.data.already_verified ? "Email già verificata." : "Email confermata."); })
      .catch(err => { setStatus("error"); setMessage(err.response?.data?.detail || "Token non valido o scaduto"); });
  }, [token]);

  return (
    <div className="max-w-[720px] mx-auto px-6 py-24 text-center">
      <Seo title={t("Conferma email")} path={`/verify-email/${token || ""}`} noindex />
      {status === "verifying" && (
        <div>
          <div className="overline text-stone-500">{t("Verifica in corso…")}</div>
          <div className="mt-6 font-serif text-4xl">{t("Stiamo controllando il tuo link.")}</div>
        </div>
      )}
      {status === "success" && (
        <div>
          <div className="text-[#8C3A3A] flex justify-center"><CheckCircle2 size={72} strokeWidth={1} /></div>
          <div className="overline text-stone-500 mt-6">{t("Verifica completata")}</div>
          <h1 className="font-serif text-5xl tracking-tighter mt-2">{t("Benvenuto ufficiale su Rarium.")}</h1>
          <p className="mt-4 text-stone-600">{message === "Email confermata." ? `${t("Email ")}${verifiedEmail}${t(" confermata.")}` : t(message)}</p>
          <div className="mt-10 flex justify-center gap-3">
            <Link to="/dashboard" data-testid="verify-dashboard-btn" className="text-xs uppercase tracking-widest font-semibold bg-stone-900 hover:bg-[#8C3A3A] text-stone-50 px-8 py-4 transition-colors">{t("Vai al dashboard")}</Link>
            <Link to="/browse" className="text-xs uppercase tracking-widest font-semibold border border-stone-900 hover:bg-stone-900 hover:text-stone-50 px-8 py-4 transition-colors">{t("Esplora aste")}</Link>
          </div>
        </div>
      )}
      {status === "error" && (
        <div>
          <div className="text-stone-500 flex justify-center"><XCircle size={72} strokeWidth={1} /></div>
          <h1 className="font-serif text-5xl tracking-tighter mt-6">{t("Link non valido.")}</h1>
          <p className="mt-4 text-stone-600">{t(message)}{t(". Puoi richiedere un nuovo link dal tuo dashboard.")}</p>
          <Link to="/dashboard" className="mt-8 inline-block text-xs uppercase tracking-widest font-semibold bg-stone-900 hover:bg-[#8C3A3A] text-stone-50 px-8 py-4 transition-colors">{t("Torna al dashboard")}</Link>
        </div>
      )}
    </div>
  );
}
